import { render, staticRenderFns } from "./studenstList.vue?vue&type=template&id=01dcbf36"
import script from "./studenstList.vue?vue&type=script&lang=js"
export * from "./studenstList.vue?vue&type=script&lang=js"
import style0 from "./studenstList.vue?vue&type=style&index=0&id=01dcbf36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports